import qs from 'qs'
import { pick } from './objOperation'

function typeMatch({ url, type }) {
  try {
    let allowType = ['search', 'hash']
    if (allowType.includes(type.toLowerCase())) {
      let urlObj
      // 修复阿里云报警 undefined is not an object (evaluating 's.targetObj')问题
      try {
        urlObj = new URL(url || location.href)
      } catch (e) {
        let isServer = typeof window === 'undefined'
        if (!isServer) {
          urlObj = document.createElement('a')
          urlObj.href = url || location.href
        }
      }
      let targetHead = ''
      if (type === 'search') {
        targetHead = '?'
      } else if (type === 'hash') {
        if (urlObj[type] && urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)) {
          urlObj[type].match(/(#\/)?[a-zA-Z0-9-_]+\??/)[0]
        } else {
          targetHead = '#/?'
        }
      }
      let targetString = urlObj[type].replace(targetHead, '')
      let targetObj
      try {
        targetObj = qs.parse(targetString) || {}
      } catch (error) {
        targetObj = {}
      }
      return { urlObj, targetObj, targetHead }
    } else {
      return false
    }
  } catch (err) {
    console.error(err)
  }
}

function addUrlParams({ url, type = 'search', params }) {
  // 利用Qs，将字符串整理为更容易处理的对象进行增加，最后再转为字符串给出去；
  let match = typeMatch({ url, type })
  if (match) {
    let { urlObj, targetObj, targetHead } = typeMatch({ url, type })
    // 合并参数
    let finalParamsStr = qs.stringify(Object.assign(targetObj, params))
    urlObj[type] = `${targetHead}${finalParamsStr}`
    return urlObj.href
  } else {
    return url
  }
}

function removeUrlParams({ url, type = 'search', params }) {
  let match = typeMatch({ url, type })
  if (match) {
    let { urlObj, targetObj, targetHead } = match
    // 移除参数
    let paramsArray = []
    if (params instanceof Array) {
      paramsArray = params
    } else if (typeof params === 'string') {
      paramsArray.push(params)
    } else {
      for (let key in params) {
        paramsArray.push(key)
      }
    }

    paramsArray.map(key => {
      targetObj[key] = undefined
    })

    let finalParamsStr = qs.stringify(Object.assign(targetObj, params))
    urlObj[type] = `${targetHead}${finalParamsStr}`
    return urlObj.href
  } else {
    return url
  }
}

function addHashParams({ url, params }) {
  return addUrlParams({ url, type: 'hash', params })
}

function removeHashParams({ url, params }) {
  return removeUrlParams({ url, type: 'hash', params })
}

/*
 * todo: hash的情不一定截取到第一个key，因为#后面的字符不可控
 */
function getUrlParams({ url, type = 'search', params = [] }) {
  let { targetObj } = typeMatch({ url, type })
  return pick(targetObj, params)
}

export {
  addUrlParams,
  removeUrlParams,
  addHashParams,
  removeHashParams,
  getUrlParams
}

export default {
  addUrlParams,
  removeUrlParams,
  addHashParams,
  removeHashParams,
  getUrlParams
}
